import { colors, IStyles } from 'theme'

export const defaultThemeStyles: IStyles = {
    textMain: colors.grey,
    hover: colors.black,
    active: colors.black,
    disable: colors.grey,
    background: colors.white,
    drop: colors.white,
    dropBackground: 'rgba(0, 0, 0, 0.45)',
}
